export default "__VITE_ASSET__BcgVbBDZ__"